import { BarChart3, Package, ShoppingCart, Users, Store, Tag, TrendingUp, FileText, Video, MessageSquare, Heart, Award, Percent, Settings as SettingsIcon, CreditCard, DollarSign, AlertCircle, CheckCircle2, Info, XCircle } from 'lucide-react';
import { CompleteAdminSidebarGuide, CompleteVendorSidebarGuide } from './CompleteSidebarGuides';

export function UltraDetailedAdminGuide() {
  return <CompleteAdminSidebarGuide />;
}

export function UltraDetailedVendorGuide() {
  return <CompleteVendorSidebarGuide />;
}